export const PERMISSIONS = {
  // Product permissions
  PRODUCTS_VIEW: 1 << 0, // 1 - Read-only access to products
  PRODUCTS_EDIT: 1 << 1, // 2 - Create / update / delete products

  // Order permissions
  ORDERS_VIEW: 1 << 2, // 4 - Read-only access to orders
  // NOTE: bit 3 is reserved for the existing ADMIN flag (value 8)
  ORDERS_REFUND: 1 << 4, // 16 – Ability to refund / change order status

  // User management permissions
  USERS_VIEW: 1 << 5, // 32 – Read-only access to users
  USERS_EDIT: 1 << 6, // 64 – Ability to create / update users

  // Coupon permissions
  COUPONS_VIEW: 1 << 7, // 128 – Read-only access to coupons
  COUPONS_EDIT: 1 << 8, // 256 – Ability to create / update / delete coupons

  // Order management permission
  ORDERS_MANAGE: 1 << 9, // 512 – Ability to manage orders (update status, capture payments, etc.)

  // Super-admin (kept as 8 to preserve existing data)
  ADMIN: 1 << 3, // 8  – Full access
} as const;

export type PermissionFlag = typeof PERMISSIONS[keyof typeof PERMISSIONS];

/**
 * Determines whether the supplied permission flags include the provided permission.
 * If the ADMIN flag is set, this will always return true.
 */
export function hasPermission(
  userPermissions: number | undefined | null,
  required: PermissionFlag
): boolean {
  if (!userPermissions) return false;
  // Super-admin short-circuit
  if ((userPermissions & PERMISSIONS.ADMIN) === PERMISSIONS.ADMIN) {
    return true;
  }
  return (userPermissions & required) === required;
} 

export function hasAnyPermission(
  userPermissions: number | undefined | null,
  required: readonly PermissionFlag[]
): boolean {
  return required.some((flag) => hasPermission(userPermissions, flag));
}
